import { useState, useEffect } from 'react';
import _ from 'lodash';
// material
import { Card, Grid, Stack, Typography, Box, TextField, Autocomplete } from '@mui/material';
import { FormikProvider, useFormik, Form } from 'formik';
import {
  classifyBasedOnVehicleType,
  fitnessCertificate,
  registrationTypeSellModule,
  vehicleGearType,
  vehicleType
} from 'utils/constants/vehicle';
import { getAllStoresApi, getAllSubCategoryApi, getBrandListApi } from 'redux/stores/storeApi';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import useAuth from 'hooks/useAuth';
import { UploadSingleFile } from 'components/upload';
import { getAllSPEmployeeApi } from 'redux/spEmployee/spEmployeeApi';
import { DatePicker } from '@mui/x-date-pickers';

export default function VehicleForm(props) {
  const {
    formRef,
    setIsButtonDisabled,
    checkVehicleExistence,
    docs,
    setDocs,
    formData,
    isEdit,
    setValueExits,
    isErrorMessage,
    setIsErrorMessage,
    errorMessage,
    setErrorMessage
  } = props;
  const dispatch = useDispatch();
  const { user = {} } = useAuth();
  const { storeList = [] } = useSelector(({ storeReducer }) => storeReducer);
  const { isSPEmployeeLoading, spEmployeeList = [] } = useSelector(({ spEmployeeReducer }) => spEmployeeReducer);

  const [subCategoryList, setSubCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [isBrandListShow, setIsBrandListShow] = useState(false);
  const [isVehicleClassifyListShow, setIsVehicleClassifyListShow] = useState(false);
  const [isVehicleNumberShow, setIsVehileNumberShow] = useState(false);
  const [transportVehicleOptions, setTransportVehicleOptions] = useState([]);
  const initialValues = {
    vehicleType: '',
    brandName: '',
    vehiclesClassify: '',
    rc_number: '',
    purchasedPrice: '',
    storeId: '',
    employeeId: '',
    maker_description: '',
    maker_model: '',
    manufacturing_date: '',
    owner_number: '',
    gear: '',
    insurance_upto: '',
    kmsdriven: '',
    fuel_type: '',
    expectedPrice: '',
    registrationType: '',
    color: '',
    body_type: '',
    seat_capacity: '',
    financer: '',
    fitnessCertificate: '',
    description: '',
    ...formData
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: (e) => {}
  });

  useEffect(() => {
    if (isEdit) {
      setIsBrandListShow(true);
      setIsVehicleClassifyListShow(true);
      setIsVehileNumberShow(true);
    }
  }, [isEdit]);

  const handleDrop = (acceptedFiles, fileName) => {
    const file = acceptedFiles[0];
    if (file) {
      const filePath = file.name.split('.').pop();
      const name = `${fileName}.${filePath}`;
      const newFile = new File([file], name, { type: file.type });
      setDocs({
        ...docs,
        [fileName]: { file: { ...newFile, preview: URL.createObjectURL(newFile) }, uploadFile: newFile }
      });
    }
  };

  useEffect(() => {
    dispatch(getAllStoresApi({ oemId: user?.oemId ? user?.oemId : '' }));
    dispatch(getAllSPEmployeeApi({ userName: user?.userName }));
  }, []);

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;
  formRef.current = formik;

  useEffect(() => {
    if (!isEdit) {
      getSubCategoryList();
    }
  }, []);

  const getSubCategoryList = async () => {
    try {
      //   setSubCatLoading(true);
      const upCategoryList = _.map(values.category, (cat) => ({ catalogName: cat?.catalogName || cat?.name }));

      let res = await dispatch(getAllSubCategoryApi({ categoryList: [{ catalogName: 'Showroom' }] }));
      res = unwrapResult(res);
      //   setSubCatLoading(false);
      // if (user?.role === USER_ROLE.OEM) {
      //   const userSubCatOpts = _.map(user?.subCategory, (cat) => cat?.name);
      //   res = _.filter(res, (category) => _.includes(userSubCatOpts, category?.catalogName));
      // }
      setSubCategoryList(res);
    } catch (err) {
      //   setSubCatLoading(false);
      console.log(err, 'err');
    }
  };

  useEffect(() => {
    if (!_.isEmpty(values.vehicleType) && !isEdit) {
      setIsBrandListShow(true);
      getBrandList();
      setIsVehicleClassifyListShow(false);
      setIsVehileNumberShow(false);
      setFieldValue('brandName', '');
      setFieldValue('rc_number', '');
    }
  }, [values.vehicleType]);

  useEffect(() => {
    if (!isEdit) {
      setFieldValue('rc_number', '');
    }
  }, []);

  const getBrandList = async () => {
    // if (!_.isEmpty(values.subCategory)) {
    try {
      let res = await dispatch(getBrandListApi({ subCategoryList: [values.vehicleType] }));
      res = unwrapResult(res);
      setBrandList(res);
    } catch (err) {
      // setBrandLoading(false);
      console.log(err, 'err');
    }
    // }
  };

  useEffect(() => {
    if (!isEdit) {
      if (values.rc_number.length >= 9) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    }
  }, [values.rc_number]);

  return (
    <>
      {/* <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          {errors.afterSubmit && <Alert severity="error">{errors.afterSubmit}</Alert>} */}

      <Grid container spacing={0}>
        <Grid item xs={12} md={8} lg={20}>
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Card sx={{ p: 3, mt: 2, paddingBottom: 2 }}>
                <Grid item xs={12} md={12} lg={12}>
                  <Autocomplete
                    options={subCategoryList}
                    filterSelectedOptions
                    sx={{ my: 2 }}
                    // disableCloseOnSelect
                    name="vehicleType"
                    //   multiple
                    //   loading={isSubCatLoading}
                    getOptionLabel={(option) => option?.catalogName || option?.name || option || ''}
                    isOptionEqualToValue={(option, value) => option?._id === value?._id}
                    value={values.vehicleType}
                    onChange={(event, value) => {
                      setFieldValue('vehicleType', value);
                    }}
                    disabled={!checkVehicleExistence}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="Vehicle Type"
                        name="vehicleType"
                        error={touched.vehicleType && errors.vehicleType}
                        helperText={touched.vehicleType && errors.vehicleType}
                      />
                    )}
                  />
                </Grid>
                {isBrandListShow && (
                  <Grid item xs={12} md={12} lg={12}>
                    {/* {values.vehicle === 'CYCLE' && ( */}
                    <Autocomplete
                      options={brandList}
                      sx={{ my: 2 }}
                      //   multiple
                      name="brandName"
                      //   loading={isBrandLoading}
                      getOptionLabel={(option) => option?.catalogName || option?.name || option || ''}
                      isOptionEqualToValue={(option, value) => option?._id === value?._id}
                      value={values.brandName}
                      disabled={!checkVehicleExistence}
                      onChange={(event, value) => {
                        setFieldValue('brandName', value);
                        if (!isEdit) {
                          setIsVehicleClassifyListShow(true);
                          const payload = vehicleType.find((t) => t.name === values.vehicleType?.catalogName);
                          setTransportVehicleOptions(
                            classifyBasedOnVehicleType.filter((option) => option.type === payload?.value)
                          );
                          setFieldValue('vehiclesClassify', '');
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="Brand Name"
                          name="brandName"
                          error={touched.brandName && errors.brandName}
                          helperText={touched.brandName && errors.brandName}
                        />
                      )}
                    />
                  </Grid>
                )}
                {isVehicleClassifyListShow && (
                  <Grid item xs={12} md={12} lg={12}>
                    {/* {values.vehicle === 'CYCLE' && ( */}
                    <Autocomplete
                      options={transportVehicleOptions}
                      sx={{ my: 2 }}
                      //   multiple
                      name="vehiclesClassify"
                      //   loading={isBrandLoading}
                      getOptionLabel={(option) => option?.label || ''}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      disabled={!checkVehicleExistence}
                      value={values.vehiclesClassify}
                      onChange={(event, value) => {
                        setFieldValue('vehiclesClassify', value);
                        setIsVehileNumberShow(true);
                        setFieldValue('rc_number', '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="Vehicles Classification"
                          name="vehiclesClassify"
                          error={touched.vehiclesClassify && errors.vehiclesClassify}
                          helperText={touched.vehiclesClassify && errors.vehiclesClassify}
                        />
                      )}
                    />
                  </Grid>
                )}
                {isVehicleNumberShow && (
                  <>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        // type="number"
                        sx={{ my: 1 }}
                        inputProps={{
                          maxLength: 10
                        }}
                        label="Vehicle Number"
                        name="rc_number"
                        disabled={!checkVehicleExistence}
                        value={values.rc_number}
                        onChange={(e) => {
                          const uppercasedValue = e.target.value.toUpperCase();
                          setFieldValue('rc_number', uppercasedValue);
                          setIsErrorMessage(false);
                          setErrorMessage('');
                        }}
                        error={touched.rc_number && errors.rc_number}
                        helperText={touched.rc_number && errors.rc_number}
                      />
                    </Grid>
                    {isErrorMessage && <Typography sx={{ color: 'red' }}>{errorMessage}</Typography>}
                  </>
                )}
                {!checkVehicleExistence && (
                  <>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Purchased Price"
                        name="purchasedPrice"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: _.isEmpty(values.purchasedPrice) ? 'green' : undefined // Default border color
                            },
                            '&:hover fieldset': {
                              borderColor: _.isEmpty(values.purchasedPrice) ? 'green' : undefined // Border color on hover
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: _.isEmpty(values.purchasedPrice) ? 'green' : undefined // Border color when focused
                            }
                          }
                        }}
                        value={values.purchasedPrice}
                        onChange={(event, value) => {
                          const getVehicle = isEdit ? values.vehicleType : values.vehicleType.catalogName;
                          let checkVehicle = 0;
                          if (getVehicle === 'Two Wheelers' || getVehicle === 'Three Wheelers') {
                            checkVehicle = 7;
                          } else {
                            checkVehicle = 8;
                          }
                          let checkEvent = event.target.value;
                          if (checkEvent.length > checkVehicle) {
                            checkEvent = checkEvent.slice(0, checkVehicle); // Truncate the value to 6 characters
                          }
                          setFieldValue('purchasedPrice', checkEvent);
                          setValueExits((prev) => ({
                            ...prev,
                            purchasedPrice: !_.isEmpty(checkEvent)
                          }));
                        }}
                        inputProps={{
                          inputMode: 'numeric',
                          autoComplete: 'new-amigo-number',
                          pattern: '[0-9]{10}',
                          form: {
                            autoComplete: 'off'
                          }
                        }}
                        error={touched.purchasedPrice && errors.purchasedPrice}
                        helperText={touched.purchasedPrice && errors.purchasedPrice}
                      />
                    </Grid>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 2 }}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={user?.role === 'EMPLOYEE' ? 12 : 6}
                        lg={user?.role === 'EMPLOYEE' ? 12 : 6}
                        xl={user?.role === 'EMPLOYEE' ? 12 : 6}
                      >
                        {/* {values.vehicle === 'CYCLE' && ( */}
                        <Autocomplete
                          // options={categoryList}
                          options={_.filter(storeList, (store) => store.profileStatus === 'ONBOARDED') || []}
                          renderOption={(props, option) => (
                            <li {...props} key={option._id}>
                              {option?.basicInfo?.businessName || option?.name || ''}
                              {option._id && <span style={{ color: 'grey' }}> ({option?.storeId}) </span>}
                            </li>
                          )}
                          filterOptions={(options, params) => {
                            // const filtered = filter(options, params);

                            // Add custom filtering based on storeId
                            const storeIdFilter = params.inputValue.toLowerCase();
                            const filteredByStoreId = options.filter(
                              (option) =>
                                option?.basicInfo?.businessName.toLowerCase().includes(storeIdFilter) ||
                                option?.label?.toLowerCase().includes(storeIdFilter) ||
                                option?.name?.toLowerCase().includes(storeIdFilter) ||
                                option?.storeId.toLowerCase().includes(storeIdFilter)
                            );

                            return [{ label: 'Select All', value: 'select-all' }, ...filteredByStoreId];
                          }}
                          getOptionLabel={(option) => option?.basicInfo?.businessName || option?.name || option || ''}
                          value={values.storeId || ''}
                          isOptionEqualToValue={(option, value) => option?.storeId === value?.storeId}
                          onChange={(event, value) => {
                            setFieldValue('storeId', value?.storeId);
                            setValueExits((prev) => ({
                              ...prev,
                              storeId: !_.isEmpty(value)
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Select the Store"
                              name="store"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: _.isEmpty(values.storeId) ? 'red' : undefined // Default border color
                                  },
                                  '&:hover fieldset': {
                                    borderColor: _.isEmpty(values.storeId) ? 'red' : undefined // Border color on hover
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: _.isEmpty(values.storeId) ? 'red' : undefined // Border color when focused
                                  }
                                }
                              }}
                              disabled={isEdit}
                              error={touched.storeId && errors.storeId}
                              helperText={touched.storeId && errors.storeId}
                            />
                          )}
                        />
                      </Grid>
                      {user?.role !== 'EMPLOYEE' && (
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <Autocomplete
                            options={spEmployeeList || []}
                            filterSelectedOptions
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Stack direction="row" alignItems="center">
                                  <Typography> {option?.employeeAuthDetails?.[0]?.userName}</Typography>
                                  <Typography> - {option.name}</Typography>
                                  <Typography> ( {option.employeeId} )</Typography>
                                </Stack>
                              </li>
                            )}
                            value={values.employeeId || ''}
                            isOptionEqualToValue={(option, value) => option?.employeeId === value?.employeeId}
                            onChange={(event, value) => {
                              setFieldValue('employeeId', value?.employeeAuthDetails?.[0]?.userName);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label="Select the Employee"
                                name="employeeId"
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                      borderColor: _.isEmpty(values.employeeId) ? 'green' : undefined // Default border color
                                    },
                                    '&:hover fieldset': {
                                      borderColor: _.isEmpty(values.employeeId) ? 'green' : undefined // Border color on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                      borderColor: _.isEmpty(values.employeeId) ? 'green' : undefined // Border color when focused
                                    }
                                  }
                                }}
                                disabled={isEdit}
                                error={touched.employeeId && errors.employeeId}
                                helperText={touched.employeeId && errors.employeeId}
                              />
                            )}
                          />
                        </Grid>
                      )}
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="Brand"
                          name="maker_description"
                          disabled
                          value={values.maker_description}
                          {...getFieldProps('maker_description')}
                          error={touched.maker_description && errors.maker_description}
                          helperText={touched.maker_description && errors.maker_description}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="Model"
                          name="maker_model"
                          disabled
                          value={values.maker_model}
                          {...getFieldProps('maker_model')}
                          error={touched.maker_model && errors.maker_model}
                          helperText={touched.maker_model && errors.maker_model}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="Manf Year"
                          name="maker_description"
                          disabled
                          value={values.manufacturing_date}
                          {...getFieldProps('manufacturing_date')}
                          error={touched.manufacturing_date && errors.manufacturing_date}
                          helperText={touched.manufacturing_date && errors.manufacturing_date}
                        />
                      </Grid>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 2 }}>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="No of owners"
                          name="owner_number"
                          value={values.owner_number}
                          disabled
                          {...getFieldProps('owner_number')}
                          error={touched.owner_number && errors.owner_number}
                          helperText={touched.owner_number && errors.owner_number}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="Fuel Type"
                          name="fuel_type"
                          value={values.fuel_type}
                          disabled
                          {...getFieldProps('fuel_type')}
                          error={touched.fuel_type && errors.fuel_type}
                          helperText={touched.fuel_type && errors.fuel_type}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="Body Type"
                          name="body_type"
                          value={values.body_type}
                          disabled
                          {...getFieldProps('body_type')}
                          error={touched.body_type && errors.body_type}
                          helperText={touched.body_type && errors.body_type}
                        />
                      </Grid>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 2 }}>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="Color"
                          name="color"
                          value={values.color}
                          disabled
                          {...getFieldProps('color')}
                          error={touched.color && errors.color}
                          helperText={touched.color && errors.color}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="No. of seats"
                          name="seat_capacity"
                          value={values.seat_capacity}
                          disabled
                          {...getFieldProps('seat_capacity')}
                          error={touched.seat_capacity && errors.seat_capacity}
                          helperText={touched.seat_capacity && errors.seat_capacity}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          // type="number"
                          label="HP / financer"
                          name="financer"
                          disabled
                          value={values.financer}
                          {...getFieldProps('financer')}
                          error={touched.financer && errors.financer}
                          helperText={touched.financer && errors.financer}
                        />
                      </Grid>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 2 }}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Autocomplete
                          options={vehicleGearType}
                          filterSelectedOptions
                          // disableCloseOnSelect
                          name="gear"
                          //   multiple
                          //   loading={isSubCatLoading}
                          getOptionLabel={(option) => option?.label || ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          value={values.gear}
                          onChange={(event, value) => {
                            setFieldValue('gear', value);
                            setValueExits((prev) => ({
                              ...prev,
                              gear: !_.isEmpty(value)
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Types of gear"
                              name="gear"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: _.isEmpty(values.gear) ? 'red' : undefined // Default border color
                                  },
                                  '&:hover fieldset': {
                                    borderColor: _.isEmpty(values.gear) ? 'red' : undefined // Border color on hover
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: _.isEmpty(values.gear) ? 'red' : undefined // Border color when focused
                                  }
                                }
                              }}
                              error={touched.gear && errors.gear}
                              helperText={touched.gear && errors.gear}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Autocomplete
                          options={registrationTypeSellModule}
                          filterSelectedOptions
                          // disableCloseOnSelect
                          name="registrationType"
                          //   multiple
                          //   loading={isSubCatLoading}
                          getOptionLabel={(option) => option?.label || ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          value={values.registrationType}
                          onChange={(event, value) => {
                            setFieldValue('registrationType', value);
                            setValueExits((prev) => ({
                              ...prev,
                              registrationType: !_.isEmpty(value)
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Registration Type"
                              name="registrationType"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: _.isEmpty(values.registrationType) ? 'red' : undefined // Default border color
                                  },
                                  '&:hover fieldset': {
                                    borderColor: _.isEmpty(values.registrationType) ? 'red' : undefined // Border color on hover
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: _.isEmpty(values.registrationType) ? 'red' : undefined // Border color when focused
                                  }
                                }
                              }}
                              error={touched.registrationType && errors.registrationType}
                              helperText={touched.registrationType && errors.registrationType}
                            />
                          )}
                        />
                      </Grid>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 2 }}>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <DatePicker
                          label="Insurance Exp."
                          fullWidth
                          value={values.insurance_upto}
                          inputFormat="dd/MM/yyyy"
                          // handleChange={(date) => setFieldValue('startDate', date)}
                          onChange={(value) => setFieldValue('insurance_upto', value)}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          type="number"
                          label="Kms Driven"
                          name="kmsdriven"
                          inputProps={{
                            inputMode: 'numeric',
                            autoComplete: 'new-amigo-number',
                            pattern: '[0-9]{10}',
                            form: {
                              autoComplete: 'off'
                            },
                            maxLength: 6
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: _.isEmpty(values.kmsdriven) ? 'red' : undefined // Default border color
                              },
                              '&:hover fieldset': {
                                borderColor: _.isEmpty(values.kmsdriven) ? 'red' : undefined // Border color on hover
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: _.isEmpty(values.kmsdriven) ? 'red' : undefined // Border color when focused
                              }
                            }
                          }}
                          onChange={(event, value) => {
                            if (event.target.value.length > 6) {
                              event.target.value = event.target.value.slice(0, 6); // Truncate the value to 6 characters
                            }
                            setFieldValue('kmsdriven', event.target.value);
                            setValueExits((prev) => ({
                              ...prev,
                              kmsdriven: !_.isEmpty(event.target.value)
                            }));
                          }}
                          value={values.kmsdriven}
                          error={touched.kmsdriven && errors.kmsdriven}
                          helperText={touched.kmsdriven && errors.kmsdriven}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <TextField
                          fullWidth
                          type="number"
                          label="Selling Price"
                          name="expectedPrice"
                          value={values.expectedPrice}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: _.isEmpty(values.expectedPrice) ? 'red' : undefined // Default border color
                              },
                              '&:hover fieldset': {
                                borderColor: _.isEmpty(values.expectedPrice) ? 'red' : undefined // Border color on hover
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: _.isEmpty(values.expectedPrice) ? 'red' : undefined // Border color when focused
                              }
                            }
                          }}
                          onChange={(event, value) => {
                            const getVehicle = isEdit ? values.vehicleType : values.vehicleType.catalogName;
                            let checkVehicle = 0;
                            if (getVehicle === 'Two Wheelers' || getVehicle === 'Three Wheelers') {
                              checkVehicle = 7;
                            } else {
                              checkVehicle = 8;
                            }
                            let checkEvent = event.target.value;
                            if (checkEvent.length > checkVehicle) {
                              checkEvent = checkEvent.slice(0, checkVehicle); // Truncate the value to 6 characters
                            }
                            setFieldValue('expectedPrice', checkEvent);
                            setValueExits((prev) => ({
                              ...prev,
                              expectedPrice: !_.isEmpty(checkEvent)
                            }));
                          }}
                          inputProps={{
                            inputMode: 'numeric',
                            autoComplete: 'new-amigo-number',
                            pattern: '[0-9]{10}',
                            form: {
                              autoComplete: 'off'
                            }
                          }}
                          error={touched.expectedPrice && errors.expectedPrice}
                          helperText={touched.expectedPrice && errors.expectedPrice}
                        />
                      </Grid>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 2 }}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Autocomplete
                          options={fitnessCertificate}
                          filterSelectedOptions
                          // disableCloseOnSelect
                          name="fitnessCertificate"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: _.isEmpty(values.fitnessCertificate) ? 'green' : undefined // Default border color
                              },
                              '&:hover fieldset': {
                                borderColor: _.isEmpty(values.fitnessCertificate) ? 'green' : undefined // Border color on hover
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: _.isEmpty(values.fitnessCertificate) ? 'green' : undefined // Border color when focused
                              }
                            }
                          }}
                          //   multiple
                          //   loading={isSubCatLoading}
                          getOptionLabel={(option) => option?.label || ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          value={values.fitnessCertificate}
                          onChange={(event, value) => {
                            setFieldValue('fitnessCertificate', value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Fitness Certificate"
                              name="fitnessCertificate"
                              error={touched.fitnessCertificate && errors.fitnessCertificate}
                              helperText={touched.fitnessCertificate && errors.fitnessCertificate}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <TextField
                          fullWidth
                          label="Decription"
                          name="description"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: _.isEmpty(values.description) ? 'green' : undefined // Default border color
                              },
                              '&:hover fieldset': {
                                borderColor: _.isEmpty(values.description) ? 'green' : undefined // Border color on hover
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: _.isEmpty(values.description) ? 'green' : undefined // Border color when focused
                              }
                            }
                          }}
                          value={values.description}
                          {...getFieldProps('description')}
                          error={touched.description && errors.description}
                          helperText={touched.description && errors.description}
                        />
                      </Grid>
                    </Stack>
                  </>
                )}
              </Card>
              {!checkVehicleExistence && (
                <Card sx={{ p: 3, mt: 2 }}>
                  <Typography sx={{ fontSize: '24px' }}>Upload min 2 images</Typography>
                  <Stack spacing={3} sx={{ mt: 2 }}>
                    <Box>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
                          justifyContent: 'space-between',
                          mt: 1
                        }}
                      >
                        <Box sx={{ marginTop: { xs: '24px', sm: '24px' } }}>
                          <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Front View Image</Typography>
                          <UploadSingleFile
                            maxSize={3145728}
                            accept="image/*"
                            file={docs?.frontView?.file}
                            onDrop={(accFile) => handleDrop(accFile, 'frontView')}
                            borderColor={_.isEmpty(docs?.frontView?.file) ? 'red' : undefined}
                          />
                        </Box>
                        <Box sx={{ marginTop: { xs: '24px', sm: '24px' } }}>
                          <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Right View Image</Typography>
                          <UploadSingleFile
                            maxSize={3145728}
                            accept="image/*"
                            file={docs?.rightView?.file}
                            onDrop={(accFile) => handleDrop(accFile, 'rightView')}
                            borderColor={_.isEmpty(docs?.rightView?.file) ? 'red' : undefined}
                          />
                        </Box>
                        <Box sx={{ marginTop: { xs: '24px', sm: '24px' } }}>
                          <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Back View Image</Typography>
                          <UploadSingleFile
                            maxSize={3145728}
                            accept="image/*"
                            file={docs?.backView?.file}
                            onDrop={(accFile) => handleDrop(accFile, 'backView')}
                            borderColor={_.isEmpty(docs?.backView?.file) ? 'red' : undefined}
                          />
                        </Box>
                      </Stack>
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
                          justifyContent: 'space-between',
                          mt: 2
                        }}
                      >
                        <Box sx={{ marginTop: { xs: '24px', sm: '24px' } }}>
                          <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Left View Image</Typography>
                          <UploadSingleFile
                            maxSize={3145728}
                            accept="image/*"
                            file={docs?.leftView?.file}
                            onDrop={(accFile) => handleDrop(accFile, 'leftView')}
                            borderColor={_.isEmpty(docs?.leftView?.file) ? 'red' : undefined}
                          />
                        </Box>
                        <Box sx={{ marginTop: { xs: '24px', sm: '24px' } }}>
                          <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Odometer Image</Typography>
                          <UploadSingleFile
                            maxSize={3145728}
                            accept="image/*"
                            file={docs?.odometer?.file}
                            onDrop={(accFile) => handleDrop(accFile, 'odometer')}
                            borderColor={_.isEmpty(docs?.odometer?.file) ? 'red' : undefined}
                          />
                        </Box>
                        <Box sx={{ marginTop: { xs: '24px', sm: '24px' } }}>
                          <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Seat View Image</Typography>
                          <UploadSingleFile
                            maxSize={3145728}
                            accept="image/*"
                            file={docs?.seatView?.file}
                            onDrop={(accFile) => handleDrop(accFile, 'seatView')}
                            borderColor={_.isEmpty(docs?.seatView?.file) ? 'red' : undefined}
                          />
                        </Box>
                      </Stack>
                    </Box>
                  </Stack>
                </Card>
              )}
            </Form>
          </FormikProvider>
        </Grid>
      </Grid>
      {/* </Form>
      </FormikProvider> */}
    </>
  );
}
